<template>
  <div class="site bbc-contain">
    <div class="navigation">
      <a
        id="home"
        class="selected"
        href="http://cx.bcc.com.cn/QRCert.aspx?c=016ZB20I20216R0M&amp;v=C#"
      >
        <img src="../assets/item1ns.png" alt="img" /><em class="under-icon-text"
          >首页</em
        ></a
      >
      <a
        id="about"
        target="_blank"
        href="http://m.bcc.com.cn/introduction/&amp;contentId=168.html"
      >
        <img src="../assets/item2ns.png" alt="img" /><em class="under-icon-text"
          >公司介绍</em
        ></a
      >
      <a
        id="portfolio"
        target="_blank"
        href="http://m.bcc.com.cn/news_list/&amp;newsCategoryId=67&amp;InfoListColumnID=4.html"
      >
        <img src="../assets/item3ns.png" alt="img" /><em class="under-icon-text"
          >业务介绍</em
        ></a
      >
      <a
        href="http://m.bcc.com.cn/introduction/&amp;contentId=173.html"
        target="_blank"
        id="contact"
      >
        <img src="../assets/item4ns.png" alt="img" /><em class="under-icon-text"
          >联系我们</em
        ></a
      >
    </div>
    <!-- header-deco 顶端装饰条  -->
    <div class="header-deco"></div>
    <!--  header logo和菜单层 -->
    <div class="header">
      <img class="logo" src="../assets/logo.png" alt="img" />
    </div>
    <!--  decoration 灰色装饰线 -->
    <div class="decoration"></div>
    <!--  home 内容层 -->
    <div class="home">
      <p class="under-slider-heading shadow">证书信息验证平台</p>
      <p class="under-slider-description shadow">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;新世纪检验认证有限责任公司作为国内知名的认证机构，累计颁发各类认证证书五万余张，率先在认证证书上使用二维码技术，实现证书信息即时验证和防伪追溯功能。查询过程中如有任何问题，请拨打客服电话：400
        016 9000
      </p>
      <div class="decoration"></div>
      <div class="column">
        <p class="column-text shadow"></p>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tbody>
            <tr>
              <th width="100" align="right" valign="top" scope="row">
                注册号：
              </th>
              <td>016ZB20I20246R0M</td>
            </tr>
            <tr>
              <th align="right" valign="top" scope="row">组织名称：</th>
              <td>山东知同文传数字科技有限公司</td>
            </tr>
            <tr>
              <th align="right" valign="top" scope="row">经营地址：</th>
              <td>济南高新区新宇路南首齐鲁软件园大厦8层 808房间</td>
            </tr>
            <tr>
              <th align="right" valign="top" scope="row">认证领域：</th>
              <td>信息安全管理体系</td>
            </tr>
            <tr>
              <th align="right" valign="top" scope="row">认证依据：</th>
              <td>GB/T 22080-2016/ISO/IEC 27001:2013</td>
            </tr>
            <tr>
              <th align="right" valign="top" scope="row">认证范围：</th>
              <td>
                与企业征信评级服务和信用咨询服务及与其相关的应用软件开发和运维服务相关的信息安全管理;适用性声明:HGZX-A-02版本:V1.0
              </td>
            </tr>
            <tr>
              <th align="right" valign="top" scope="row">证书有效期：</th>
              <td>2024-06-12 至 2027-06-11</td>
            </tr>
            <tr>
              <th align="right" valign="top" scope="row">证书状态：</th>
              <td id="situation">有效</td>
            </tr>
            <!-- <tr id="revoke" style="display: none">
              <th align="right" valign="top" scope="row">撤销日期：</th>
              <td>[cert_revoke_time]</td>
            </tr>
            <tr>
              <th align="right" valign="top" scope="row">二阶段审核：</th>
              <td>2020-05-26 至 2020-05-30</td>
            </tr>
            <tr>
              <th align="right" valign="top" scope="row">审核组成员：</th>
              <td>组长：马军荣 ，组员：王维晶</td>
            </tr>
            <tr>
              <th align="right" valign="top" scope="row">监一审核：</th>
              <td>2021-06-28 至 2021-06-30</td>
            </tr>
            <tr>
              <th align="right" valign="top" scope="row">审核组成员：</th>
              <td>组长：马军荣 ，组员：靳春红</td>
            </tr>
            <tr>
              <th align="right" valign="top" scope="row">监二审核：</th>
              <td>2022-09-26 至 2022-09-29</td>
            </tr>
            <tr>
              <th align="right" valign="top" scope="row">审核组成员：</th>
              <td>组长：秦芳</td>
            </tr> -->
          </tbody>
        </table>
        <p></p>
        <div class="clear"></div>
      </div>
      <div class="decoration"></div>
      <!-- <div class="column">
        <p class="column-text shadow">
          <strong>客户介绍</strong>&nbsp;&nbsp;&nbsp;&nbsp;
          惠国征信服务股份有限公司属国资控股的高新技术企业，是一家专业从事征信技术研发及应用的全国性信用服务机构，以社会信用服务、企业金融服务、金融科技产品研发为主要业务发展方向。公司产品包括社会体系建设及运营、中小企业大数据信用贷、综合金融服务平台建设及运营、物联网智能风控系统、企业尽调报告智能生成系统等。
        </p>
        <div class="clear"></div>
      </div> -->
    </div>
    <div class="decoration"></div>
    <div class="column">
      <p class="column-text shadow">
        <!-- <strong style="display: inline">二维码查询次数：</strong>
        72次，&nbsp;&nbsp;&nbsp;&nbsp;<strong style="display: inline"
          >最近一次查询于：</strong
        >
        2024-10-12
      </p> -->
      </p>

      <div class="clear"></div>
    </div>
    <!--  home 内容层 -->
    <div class="footer">
      <div id="tweets"></div>
      <p class="copyright">版权所有 新世纪检验认证有限责任公司</p>
    </div>
    <div class="empty-clear-menu"></div>
  </div>
</template>

<script>
export default {};
</script>
 
<style  lang = "scss"  scoped>
// @charset "utf-8";
@import url("http://fonts.googleapis.com/css?family=PT+Sans:400,700,400italic,700italic");
/* CSS Document */

// @media screen and (min-width: 900px) {
//   .site {
//     display: none;
//     text-align: left;
//   }
// }

// @media screen and (max-width: 899px) {
//   .no-mobile {
//     display: none;
//   }
// }
.bbc-contain {
  padding: 10px;
  margin: 10px;
}
.no-mobile {
  text-align: center;
  font-size: 24px;
  width: 500px;
  margin: auto;
  font-size: "PT Sans", sans-serif;
  padding-top: 200px;
  line-height: 40px;
}

.navigation {
  // background-image: url(../images/nav/nav-bg.png);
  background-repeat: repeat-x;
  height: 49px;
  display: block;
  margin-left: -10px;
  padding-right: 14px;
  width: 102%;
  bottom: 0px;
  position: fixed !important;
  z-index: 9999;
  background: #fff;
}

#hidepage {
  z-index: 999999;
  position: absolute;
  left: 0px;
  top: 0px;
  background-color: #fff;
  layer-background-color: #fff;
  height: 700px;
  width: 100%;
}

#hidepage img {
  padding-top: 20px;
}

.center-text {
  padding-top: 150px;
  text-align: center;
}

* {
  margin: 0px;
  border: 0px;
  padding: 0px;
  font-family: "PT Sans", sans-serif;
  -webkit-text-size-adjust: none;
}

.home {
}
.about {
  display: none;
}
.portfolio {
  display: none;
}
.blog {
  display: none;
}
.contact {
  display: none;
}

.empty-clear-menu {
  height: 50px;
}

.clear {
  clear: both;
}

.header-deco {
  // background-image: url(../images/background/header-deco.png);
  background-repeat: repeat-x;
  height: 7px;
  margin-left: -10px;
  padding-right: 10px;
  width: 102%;
  margin-top: -3px;
}

.header {
  padding-top: 15px;
  margin-bottom: 15px;
}

.social-icons {
  float: right;
}

.social-icons img {
  padding-left: 10px;
}

.decoration {
  // background-image: url(../images/background/deco_style_1.png);
  height: 2px;
  width: 100%;
  display: block;
  background-repeat: repeat-x;
  padding-bottom: 20px;
}

.image-deco {
  padding: 3px;
  -webkit-box-shadow: 0px 1px 1px 1px rgba(202, 202, 202, 0.8);
  -moz-box-shadow: 0px 1px 1px 1px rgba(202, 202, 202, 0.8);
  box-shadow: 0px 1px 1px 1px rgba(202, 202, 202, 0.8);
}

.image-width {
  width: 98%;
}

.round-icon {
  float: left;
  opacity: 0.8;
  filter: alpha(opacity=80);
  width: 32px;
  height: 33px;
  // background-image: url(../images/icon-bg/gray_bg.png);
  background-repeat: no-repeat;
  padding-right: 10px;
  padding-bottom: 2px;
  margin-top: 5px;
}

.footer {
  border-top-style: solid;
  border-top-width: 3px;
  border-top-color: #ccc;
  // background-image: url(../images/background/footer-bg.png);
  background-repeat: repeat;
  margin-left: -10px;
  width: 102%;
  padding-right: 14px;
  margin-bottom: -1px;
}

/*//////////////////*/
/*Notification Boxes*/
/*//////////////////*/

.notification-box-green {
  margin-bottom: 20px;
  width: 100%;
  height: 32px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  border-color: #3ca730;
  background-color: rgba(60, 167, 48, 0.3);
}

.notification-box-green a {
  display: block;
  overflow: hidden;
}

.notification-box-yellow {
  margin-bottom: 20px;
  width: 100%;
  height: 32px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  border-color: #cda51b;
  background-color: rgba(255, 210, 1, 0.5);
}

.notification-box-yellow a {
  display: block;
  overflow: hidden;
}

.notification-box-blue {
  margin-bottom: 20px;
  width: 100%;
  height: 32px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  border-color: #649bae;
  background-color: rgba(100, 155, 174, 0.5);
}

.notification-box-blue a {
  display: block;
  overflow: hidden;
}

.notification-box-red {
  margin-bottom: 20px;
  width: 100%;
  height: 32px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  border-color: #c24747;
  background-color: rgba(219, 84, 84, 0.5);
}

.notification-box-red a {
  display: block;
  overflow: hidden;
}

.notification-icon {
  padding-top: 9px;
  padding-left: 10px;
  float: left;
}

.notification-text {
  float: left;
  margin-top: 7px;
  padding-left: 20px;
}

.notification-quit-green {
  float: left;
  font-weight: bold;
  font-family: Verdana, Geneva, sans-serif;
  font-size: 11px;
  padding-top: 8px;
  margin-left: 90%;
  position: absolute;
  color: #3ca730 !important;
}

.notification-quit-yellow {
  float: left;
  font-weight: bold;
  font-family: Verdana, Geneva, sans-serif;
  font-size: 11px;
  padding-top: 8px;
  margin-left: 90%;
  position: absolute;
  color: #cda51b !important;
}

.notification-quit-blue {
  float: left;
  font-weight: bold;
  font-family: Verdana, Geneva, sans-serif;
  font-size: 11px;
  padding-top: 8px;
  margin-left: 90%;
  position: absolute;
  color: #649bae !important;
}

.notification-quit-red {
  float: left;
  font-weight: bold;
  font-family: Verdana, Geneva, sans-serif;
  font-size: 11px;
  padding-top: 8px;
  margin-left: 90%;
  position: absolute;
  color: #c24747 !important;
}

/*/////////*/
/*Blog Post*/
/*/////////*/

.blog-post img {
  margin-bottom: 10px;
}

.blog-post p {
  padding-bottom: 20px;
}

ul.blog-post-details {
  margin-bottom: 10px;
}

li.posted-by {
  list-style: none;
  // background-image: url(../images/blog-lists/user.png);
  background-repeat: no-repeat;
  font-size: 14px;
  background-position-y: 1px;
  padding-left: 20px;
  margin-left: 2px;
  padding-right: 12px;
  color: #5b5b5b;
  float: left;
  padding-bottom: 10px;
  font-family: "PT Sans", sans-serif;
}

li.posted-at {
  list-style: none;
  // background-image: url(../images/blog-lists/clock.png);
  background-repeat: no-repeat;
  font-size: 14px;
  background-position-y: 1px;
  padding-left: 20px;
  padding-right: 12px;
  color: #5b5b5b;
  float: left;
  padding-bottom: 10px;
  font-family: "PT Sans", sans-serif;
}

li.posted-in {
  list-style: none;
  // background-image: url(../images/blog-lists/tags.png);
  background-repeat: no-repeat;
  font-size: 14px;
  background-position-y: 1px;
  padding-left: 20px;
  padding-right: 12px;
  color: #5b5b5b;
  float: left;
  padding-bottom: 10px;
  font-family: "PT Sans", sans-serif;
}

li.posted-mo {
  list-style: none;
  // background-image: url(../images/blog-lists/more.png);
  background-repeat: no-repeat;
  font-size: 14px;
  background-position-y: 1px;
  padding-left: 20px;
  color: #5b5b5b;
  float: left;
  padding-bottom: 10px;
  font-family: "PT Sans", sans-serif;
}

/*////////////*/
/*Contact Form*/
/*////////////*/

#nameError {
  position: absolute;
  font-size: 14px;
  color: #e34e47;
  margin-top: -70px;
  right: 10px;
}

#emailError {
  position: absolute;
  font-size: 14px;
  color: #e34e47;
  margin-top: -70px;
  right: 10px;
}

#emailError2 {
  position: absolute;
  font-size: 14px;
  color: #e34e47;
  margin-top: -70px;
  right: 10px;
}

#messageError {
  position: absolute;
  font-size: 14px;
  color: #e34e47;
  margin-top: -105px;
  right: 10px;
}

.contactButton {
  margin-top: 15px;
  padding: 10px 10px !important;
}

.contactBut {
  padding: 8px 10px !important;
}

label#name_label {
  display: block;
  margin-top: -10px !important;
  font-family: "PT Sans", sans-serif;
  font-weight: bold;
  font-size: 16px;
  text-shadow: 0px 1px 0px #ffffff;
  color: #5b5b5b;
  line-height: 40px;
  padding-left: 3px;
}

label#email_label {
  display: block;
  font-family: "PT Sans", sans-serif;
  font-weight: bold;
  font-size: 16px;
  text-shadow: 0px 1px 0px #ffffff;
  color: #5b5b5b;
  line-height: 40px;
  padding-left: 3px;
}

label#message_label {
  display: block;
  font-family: "PT Sans", sans-serif;
  font-weight: bold;
  font-size: 16px;
  text-shadow: 0px 1px 0px #ffffff;
  color: #5b5b5b;
  line-height: 40px;
  padding-left: 3px;
}

#contactName {
  width: 92%;
  height: 30px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
  text-transform: capitalize;
  border-style: solid;
  border-width: 2px;
  border-color: #cacaca;
}

#contactName:focus {
  border-color: #e34e47;
}

#successMessage {
  margin-top: -10px !important;
  padding-bottom: 181px;
}

#contactEmail {
  width: 92%;
  height: 30px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
  text-transform: lowercase;
  border-style: solid;
  border-width: 2px;
  border-color: #cacaca;
}

#contactEmail:focus {
  border-color: #e34e47;
}

#contactMessage {
  padding: 10px;
  width: 92%;
  height: 50px;
  border-style: solid;
  border-width: 2px;
  border-color: #cacaca;
}

#contactMessage:focus {
  border-color: #e34e47;
}

/*Big Columns */

.left-column-big-icon {
  float: left;
  // background-image: url(../images/columns/left.png);
  background-repeat: no-repeat;
  width: 88px;
  height: 177px;
  padding-right: 20px;
}

.left-column-big-title {
  padding-bottom: 10px;
  font-size: 18px;
  display: block;
}

.left-column-big-text {
  line-height: 20px;
  width: 100%;
  float: left;
  margin-left: -10px;
  padding-bottom: 20px;
}

.right-column-big-icon {
  float: right;
  // background-image: url(../images/columns/right.png);
  background-repeat: no-repeat;
  width: 88px;
  height: 177px;
  margin-right: -10px;
  margin-left: 20px;
}

.right-column-big-title {
  padding-bottom: 10px;
  font-size: 18px;
  display: block;
}

.right-column-big-text {
  line-height: 20px;
  width: 100%;
  float: left;
  padding-bottom: 20px;
}

#E_table {
  font-size: 14px;
}
@charset "utf-8";
/* CSS Document */

html,
body,
form,
fieldset,
p,
div,
h1,
h2,
h3,
h4,
h5,
h6 {
  -webkit-text-size-adjust: none;
}

p {
  line-height: 20px;
  color: #5b5b5b;
  font-size: 14px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: #5b5b5b;
  padding-bottom: 10px;
}

.image-heading {
  padding-bottom: 10px;
  padding-top: 5px;
}

a {
  color: #24adef;
  text-decoration: none;
}

.shadow {
  text-shadow: 0px 1px 0px #ffffff;
}

.navigation a {
  width: 20%;
  float: left;
  color: #696969;
  text-decoration: none;
  text-align: center;
  padding-top: 3px;
  padding-bottom: 3px;
}

.under-icon-text {
  margin-top: -5px;
  font-family: "PT-Sans", sans-serif;
  display: block;
  font-size: 10px;
  font-style: normal;
}

.selected {
  background-color: rgba(255, 255, 255, 0.1);
}

.under-slider-heading {
  font-family: "PT-Sans", sans-serif;
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #5b5b5b;
  margin-bottom: 10px;
}

.under-slider-description {
  font-family: "PT-Sans", sans-serif;
  color: #5b5b5b;
  width: 100%;
  text-align: left;
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 20px;
}

.column {
  padding-bottom: 20px;
  th {
    white-space: nowrap;
  }
}

.column-text {
  float: left;
  padding-bottom: 20px;
}
.column-text-heading {
  font-family: "PT-Sans", sans-serif;
  width: 100%;
  /*text-align:center;*/
  font-size: 16px;
  font-weight: bold;
  color: #5b5b5b;
  margin-bottom: 10px;
}

.column-text strong {
  margin-top: -20px;
  display: block;
  padding-top: 20px;
  padding-bottom: 5px;
  font-size: 15px !important;
}

.full-width {
  width: 100%;
  padding-bottom: 20px;
}

/*////////////*/
/*Twitter Feed*/
/*////////////*/

p.tweet_link_0 {
  color: #f7f9f6;
  font-size: 14px;
}
p.tweet_link_1 {
  color: #f7f9f6;
  font-size: 14px;
}
p.tweet_link_2 {
  color: #f7f9f6;
  font-size: 14px;
}
p.tweet_link_3 {
  color: #f7f9f6;
  font-size: 14px;
}
p.tweet_link_4 {
  color: #f7f9f6;
  font-size: 14px;
}
small {
  font-style: italic;
  display: none;
}
#tweet_link_0 {
  color: #86b901;
}

#tweets li {
  list-style: none;
  // background-image: url(../images/icon/twitter.png);
  background-position: 0px 3px;
  background-repeat: no-repeat;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 35px;
  color: #000000;
  border-bottom-style: dotted;
  border-bottom-width: 1px;
  border-bottom-color: #5b5b5b;
}

#tweets li.tweet_content_0 {
  border-top: 0px none;
}
#tweets .hash {
  color: #86b901;
}
#tweets .reply {
  color: #fff;
}

.copyright {
  font-size: 10px;
  text-align: center;
  padding-bottom: 10px;
  padding-top: 10px;
  color: #ffffff !important;
}

/*/////*/
/*Lists*/
/*/////*/

.icon-list {
  color: #5b5b5b;
  padding-top: 5px; /*Corectional value for each icon being moved to suit the background icon*/
}

li.list-info {
  list-style: none;
  font-size: 14px;
  padding-bottom: 17px;
  padding-top: 3px;
  // background-image: url(../images/lists/list-info.png);
  background-repeat: no-repeat;
  background-position: 0px 3px;
  padding-left: 30px;
  margin-top: -2px;
}
li.list-heart {
  list-style: none;
  font-size: 14px;
  padding-bottom: 17px;
  padding-top: 2px;
  // background-image: url(../images/lists/list-heart.png);
  background-repeat: no-repeat;
  background-position: 0px 3px;
  padding-left: 30px;
}
li.list-attention {
  list-style: none;
  font-size: 14px;
  padding-bottom: 17px;
  padding-top: 3px;
  // background-image: url(../images/lists/list-attention.png);
  background-repeat: no-repeat;
  background-position: 0px 3px;
  padding-left: 30px;
}
li.list-cross {
  list-style: none;
  font-size: 14px;
  padding-bottom: 17px;
  padding-top: 4px;
  // background-image: url(../images/lists/list-cross.png);
  background-repeat: no-repeat;
  background-position: 0px 3px;
  padding-left: 30px;
}
li.list-arrow {
  list-style: none;
  font-size: 14px;
  padding-bottom: 17px;
  padding-top: 3px;
  // background-image: url(../images/lists/list-arrow.png);
  background-repeat: no-repeat;
  background-position: 0px 3px;
  padding-left: 30px;
}
li.list-plus {
  list-style: none;
  font-size: 14px;
  padding-bottom: 17px;
  padding-top: 3px;
  // background-image: url(../images/lists/list-plus.png);
  background-repeat: no-repeat;
  background-position: 0px 2px;
  padding-left: 30px;
}
li.list-warning {
  list-style: none;
  font-size: 14px;
  padding-bottom: 17px;
  padding-top: 3px;
  // background-image: url(../images/lists/list-warning.png);
  background-repeat: no-repeat;
  background-position: 0px 2px;
  padding-left: 30px;
}

li.list-tick {
  list-style: none;
  font-size: 14px;
  padding-bottom: 17px;
  padding-top: 3px;
  // background-image: url(../images/lists/list-tick.png);
  background-repeat: no-repeat;
  background-position: 0px 2px;
  padding-left: 30px;
}

.last-item {
  padding-bottom: 0px !important;
  margin-bottom: 0px !important;
}

/*/////////////////////////*/
/*Highlights and Selections*/
/*/////////////////////////*/

/*Orange Highlights And Selections*/

.highlight {
  padding-bottom: 15px;
}

.highlight-orange {
  background-color: #e34e47;
  color: #ffffff;
  text-shadow: none;
  margin-top: 5px;
  padding: 2px;
}
.highlight-green {
  background-color: #518900;
  color: #ffffff;
  text-shadow: none;
  margin-top: 5px;
  padding: 2px;
}
.highlight-yellow {
  background-color: #ffd100;
  text-shadow: none;
  margin-top: 5px;
  padding: 2px;
}
.highlight-gray {
  background-color: #424242;
  color: #ffffff;
  text-shadow: none;
  margin-top: 5px;
  padding: 2px;
}
</style>